var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.viewLayout,{tag:"Component",scopedSlots:_vm._u([{key:"page-heading",fn:function(){return [_c('h1',{staticClass:"heading heading--large"},[_vm._v(" Funil de sucesso ")])]},proxy:true},{key:"page-filter",fn:function(){return [_c('CommonPageFilter',{attrs:{"filters":[
        'dateRange',
        'action',
        'plugin',
        'csat',
        'feeling'
      ]}})]},proxy:true},{key:"main",fn:function(){return [_c('div',{staticClass:"leads-journey"},[_c('BaseGrid',{attrs:{"columns":"1","dense":""}},[_c('WidgetAcquisitionFunnel')],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }